import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconLusailMinimapMarkers = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={375}
    height={375}
    fill="none"
    viewBox="0 0 375 375"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#icon-lusail-minimap-markers_svg__a)">
      <path
        fill="url(#icon-lusail-minimap-markers_svg__b)"
        fillOpacity={0.2}
        stroke="#fff"
        strokeOpacity={0.1}
        strokeWidth={10}
        d="M51.242 86.829c-4.16-1.902-9.558-1.288-11.737-.743 0 0-6.537 1.932-13.074 4.309-6.538 2.377-9.51 3.566-9.51 3.566-5.497 3.12-6.388 5.942-8.32 11.143-1.545 4.16.248 9.657 1.338 11.885 7.676 22.336 23.98 69.741 27.783 80.676 4.754 13.669 11.589 15.452 13.372 16.789.471.353 2.438 1.444 5.2 2.932 7.685 4.139 21.528 11.351 26.446 14.302.816.49 1.569.989 2.26 1.504 4.969 3.697 6.785 8.202 6.654 16.028-.059 3.554-2.113 6.739-4.662 9.28-2.566 2.556-5.632 4.46-7.67 5.429-1.207.673-2.49 1.391-3.822 2.137-6.307 3.536-13.685 7.696-19.206 10.64-2.493 1.33-4.815 2.341-7.294 3.704-2.692 1.48-5.568 3.377-9.05 6.548-4.91 4.475-4.358 13.124-3.417 16.491 4.606 12.332 15.155 11.886 19.464 11.886.964 0 15.658.03 38.003.076 52.844.11 148.478.311 206.5.428a183984.053 183984.053 0 0 0 48.484.091c10.252 0 13.372-5.2 14.412-6.389 1.04-1.189 2.971-3.566 3.714-10.103.594-5.23-5.596-14.857-8.766-19.017-3.271-4.622-6.978-10.001-10.844-15.688-15.274-22.471-33.023-49.755-36.105-54.142-2.066-2.94-3.367-4.902-4.244-7.091-.763-1.905-1.205-3.982-1.551-7.024-.465-4.092 1.769-8.33 3.712-10.976a18.788 18.788 0 0 1 1.488-1.801l6.163-7.199c11.553-13.5 27.402-32.033 32.889-38.5a253.08 253.08 0 0 0 1.806-2.142c2.823-3.417 4.606-6.983 5.497-11.588.714-3.685-1.386-8.667-2.525-10.698-5.844-10.598-17.799-32.27-18.869-34.172-1.337-2.377-3.154-4.881-6.537-6.686-4.457-2.377-8.073-2.179-9.955-2.228h-22.286c-4.16 0-9.459.891-11.589 1.337-8.914 1.783-15.303 11.292-17.086 15.898-1.782 4.605-10.4 25.851-15.006 37.737-4.16 10.736-11.593 29.351-25.802 43.254a69.76 69.76 0 0 1-4.804 4.29c-17.383 14.114-29.714 16.789-35.657 18.571-5.943 1.783-9.361 1.635-12.183 1.04-2.823-.594-5.349-1.931-7.726-5.497-2.802-4.203-1.783-8.468-1.486-10.697.848-3.126 1.942-7.196 3.077-11.419 2.711-10.094 5.651-21.069 5.986-22.159.594-1.931 1.783-6.091 1.189-10.846-.484-3.869-1.755-6.558-5.896-10.468a67.26 67.26 0 0 0-3.316-2.903c-6.834-5.646-10.846-10.549-16.046-18.126-5.2-7.578-8.914-19.76-9.806-23.475-.891-3.714-1.931-9.211-4.903-12.777-2.971-3.566-8.171-6.092-13.223-6.092-4.041 0-7.825 2.08-9.211 3.12-3.933 2.47-6.007 7.502-6.912 11.225a22.213 22.213 0 0 0-.517 2.89l-1.154 9.11-1.286 10.141A20244.2 20244.2 0 0 1 98 138.618c-.99 7.64-1.666 12.729-1.74 12.989l-.006.022c-.311 1.09-1.818 6.368-7.868 6.515-4.874.119-7.677-3.714-8.469-5.645a2803.243 2803.243 0 0 1-3.765-10.999c-2.26-6.638-4.778-14.07-7.14-21-4.3-12.614-8.083-23.568-8.855-25.054-1.931-3.714-3.715-6.24-8.915-8.617Z"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M343 315.921c-8.006-.014-23.165-.043-42.5-.082"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M358.344 280.42c3.17 4.16 9.36 13.788 8.766 19.018-.743 6.537-2.674 8.914-3.714 10.103-1.04 1.188-4.16 6.389-14.412 6.389-.723 0-2.781-.003-5.984-.009"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M358.344 280.42c-3.271-4.621-6.978-10-10.844-15.687"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M307.148 203.5c.877 2.189 2.178 4.151 4.244 7.091 3.083 4.387 20.831 31.671 36.105 54.142"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M309.313 185.5c-1.943 2.646-4.177 6.884-3.712 10.976.346 3.042.788 5.119 1.551 7.024"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="m316.964 176.5-6.163 7.199a18.632 18.632 0 0 0-1.489 1.801"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M349.85 138c-5.487 6.467-21.336 25-32.889 38.5"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M268.309 87.72c1.782-4.605 8.171-14.114 17.086-15.897 2.129-.446 7.428-1.337 11.588-1.337h22.287c1.882.05 5.497-.149 9.954 2.228 3.383 1.805 5.2 4.31 6.537 6.686 1.07 1.902 13.025 23.574 18.869 34.172 1.139 2.031 3.239 7.013 2.526 10.698-.892 4.605-2.675 8.171-5.498 11.588-.274.333-.898 1.072-1.805 2.141"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M268.308 87.72c-1.782 4.606-10.4 25.853-15.006 37.738-4.16 10.736-11.593 29.351-25.802 43.254"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M187.039 191.574c5.943-1.783 18.275-4.458 35.658-18.572a69.743 69.743 0 0 0 4.803-4.29"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M165.645 176.419c-.297 2.229-1.316 6.494 1.486 10.697 2.377 3.566 4.902 4.903 7.725 5.497 2.823.595 6.24.743 12.183-1.04"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M165.645 176.419A5647.31 5647.31 0 0 0 168.721 165"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M174.705 142.841c-.335 1.09-3.275 12.065-5.986 22.159"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M174.707 142.841c.594-1.931 1.783-6.091 1.189-10.846-.484-3.869-1.755-6.558-5.896-10.468"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M140.832 77.023c.891 3.714 4.606 15.897 9.806 23.475 5.2 7.577 9.211 12.48 16.046 18.126a66.737 66.737 0 0 1 3.316 2.903"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M140.835 77.023c-.891-3.714-1.931-9.211-4.903-12.777-2.971-3.566-8.172-6.092-13.223-6.092-4.041 0-7.825 2.08-9.212 3.12-3.932 2.47-6.006 7.502-6.911 11.225"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="m104.914 84.5 1.154-9.111c.08-.776.246-1.774.517-2.89"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="m103.625 94.64 1.287-10.14"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M98 138.618c1.488-11.478 3.686-28.712 5.626-43.978"
      />
      <path
        stroke="#00FF2B"
        strokeLinecap="round"
        strokeWidth={4}
        d="M76.152 141.499c1.384 4.063 2.67 7.829 3.766 10.999.792 1.932 3.595 5.765 8.468 5.646 6.092-.148 7.578-5.497 7.875-6.537.074-.26.75-5.349 1.74-12.989"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M69.012 120.5c2.362 6.93 4.88 14.362 7.14 21"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M60.156 95.446c.773 1.486 4.556 12.44 8.855 25.054"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M60.157 95.446c-1.931-3.714-3.715-6.24-8.915-8.617-4.16-1.902-9.558-1.288-11.737-.743 0 0-6.537 1.932-13.074 4.309-6.538 2.377-9.51 3.566-9.51 3.566-5.497 3.12-6.388 5.942-8.32 11.143-1.545 4.16.248 9.657 1.338 11.886"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M9.938 116.989c7.676 22.336 23.98 69.741 27.783 80.676 4.754 13.669 11.589 15.451 13.371 16.789.472.353 2.439 1.444 5.2 2.932"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M85 233.191a27.46 27.46 0 0 0-2.26-1.503c-4.92-2.951-18.762-10.163-26.447-14.302"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M86.992 258.499c2.549-2.54 4.603-5.725 4.662-9.279.13-7.826-1.685-12.331-6.654-16.029"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M75.5 266.066c1.331-.746 2.615-1.464 3.823-2.137 2.037-.969 5.103-2.873 7.669-5.429"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M49 280.41c2.479-1.363 4.8-2.374 7.294-3.704 5.52-2.944 12.899-7.104 19.206-10.64"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M55.998 315.336c-4.309 0-14.857.445-19.463-11.886-.941-3.368-1.494-12.017 3.417-16.492 3.481-3.171 6.358-5.067 9.05-6.548"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M55.996 315.335c.964 0 15.658.03 38.003.076"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M94 315.411c52.844.109 148.478.311 206.5.428"
      />
      <g filter="url(#icon-lusail-minimap-markers_svg__c)">
        <path
          fill="#fff"
          fillOpacity={0.95}
          d="M171.262 295.111h4.028v4.526h-4.028zM171.262 304.163h4.028v4.526h-4.028zM171.262 313.214h4.028v4.526h-4.028zM171.262 322.266h4.028v4.526h-4.028zM171.262 331.317h4.028v4.526h-4.028zM175.289 299.637h4.028v4.526h-4.028z"
        />
        <path
          fill="#fff"
          fillOpacity={0.95}
          d="M175.289 308.688h4.028v4.526h-4.028zM175.289 317.74h4.028v4.526h-4.028zM175.289 326.792h4.028v4.526h-4.028z"
        />
        <path
          fill="#000"
          d="M175.289 295.111h4.028v4.526h-4.028zM175.289 304.163h4.028v4.526h-4.028zM175.289 313.214h4.028v4.526h-4.028zM175.289 322.266h4.028v4.526h-4.028zM175.289 331.317h4.028v4.526h-4.028zM171.262 299.637h4.028v4.526h-4.028z"
        />
        <path
          fill="#000"
          d="M171.262 308.688h4.028v4.526h-4.028zM171.262 317.74h4.028v4.526h-4.028zM171.262 326.792h4.028v4.526h-4.028z"
        />
        <path
          fill="#E2645A"
          d="m145.33 341.493 14.819 9.856v-19.761l-14.819 9.905Zm-2.264 0c0-.728.299-1.408.897-1.796l15.546-10.342c1.196-.825 2.69.146 2.69 1.748v20.78c0 1.554-1.494 2.574-2.69 1.797l-15.546-10.39a2.21 2.21 0 0 1-.897-1.797Z"
        />
      </g>
      <g filter="url(#icon-lusail-minimap-markers_svg__d)">
        <rect
          width={20.8}
          height={20.8}
          x={43.195}
          y={287.107}
          fill="url(#icon-lusail-minimap-markers_svg__e)"
          rx={10.4}
        />
        <g filter="url(#icon-lusail-minimap-markers_svg__f)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m53.422 295.183-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
          />
        </g>
      </g>
      <g filter="url(#icon-lusail-minimap-markers_svg__g)">
        <rect
          width={20.8}
          height={20.8}
          x={63.996}
          y={236.592}
          fill="url(#icon-lusail-minimap-markers_svg__h)"
          rx={10.4}
        />
        <g filter="url(#icon-lusail-minimap-markers_svg__i)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m71.4 249.828 4.345-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236H75.9l1.236 1.236v1.752l-4.308 3.972v.252h4.356v1.188H71.4v-1.764Z"
          />
        </g>
      </g>
      <g filter="url(#icon-lusail-minimap-markers_svg__j)">
        <rect
          width={20.8}
          height={20.8}
          x={44.98}
          y={186.968}
          fill="url(#icon-lusail-minimap-markers_svg__k)"
          rx={10.4}
        />
        <g filter="url(#icon-lusail-minimap-markers_svg__l)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M52.167 200.732v-1.188h1.392v.768l.468.456h2.28l.468-.456v-1.524l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456H54.1l-.468.456v.768H52.24v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34l-1.236 1.236h-3.528l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-lusail-minimap-markers_svg__m)">
        <rect
          width={20.8}
          height={20.8}
          x={15.563}
          y={99.31}
          fill="url(#icon-lusail-minimap-markers_svg__n)"
          rx={10.4}
        />
        <g filter="url(#icon-lusail-minimap-markers_svg__o)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M26.67 112.702h-4.08v-1.572l3.684-5.22h1.788v5.592h1.02v1.2h-1.02v1.608H26.67v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
          />
        </g>
      </g>
      <g filter="url(#icon-lusail-minimap-markers_svg__p)">
        <rect
          width={20.8}
          height={20.8}
          x={47.355}
          y={61.869}
          fill="url(#icon-lusail-minimap-markers_svg__q)"
          rx={10.4}
        />
        <g filter="url(#icon-lusail-minimap-markers_svg__r)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M54.645 75.633V74.41h1.392v.804l.468.456h2.256l.468-.456V73.15l-.468-.468h-3.996V68.47h5.688v1.2h-4.32v1.812h3.24l1.248 1.248v2.904l-1.236 1.236H55.88l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-lusail-minimap-markers_svg__s)">
        <rect
          width={20.8}
          height={20.8}
          x={84.797}
          y={163.791}
          fill="url(#icon-lusail-minimap-markers_svg__t)"
          rx={10.4}
        />
        <g filter="url(#icon-lusail-minimap-markers_svg__u)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M92.106 177.555v-5.928l1.237-1.236h3.528l1.236 1.236v1.104h-1.392v-.66l-.48-.48h-2.257l-.48.48v2.256l.792-.78h2.628l1.236 1.236v2.772l-1.236 1.236h-3.576l-1.236-1.236Zm4.177.036.48-.48v-1.884l-.48-.48h-1.8l-.984 1.008v1.356l.48.48h2.303Z"
          />
        </g>
      </g>
      <g filter="url(#icon-lusail-minimap-markers_svg__v)">
        <rect
          width={20.8}
          height={20.8}
          x={156.41}
          y={82.669}
          fill="url(#icon-lusail-minimap-markers_svg__w)"
          rx={10.4}
        />
        <g filter="url(#icon-lusail-minimap-markers_svg__x)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M163.566 96.433v-2.34l.756-.756-.636-.636v-2.196l1.236-1.236h3.528l1.236 1.236v2.196l-.636.636.756.756v2.34l-1.236 1.236h-3.768l-1.236-1.236Zm4.248-3.612.48-.48V90.95l-.48-.48h-2.256l-.48.48v1.392l.48.48h2.256Zm.12 3.648.48-.48v-1.524l-.48-.468h-2.496l-.48.468v1.524l.48.48h2.496Z"
          />
        </g>
      </g>
      <g filter="url(#icon-lusail-minimap-markers_svg__y)">
        <rect
          width={20.8}
          height={20.8}
          x={112.434}
          y={65.138}
          fill="url(#icon-lusail-minimap-markers_svg__z)"
          rx={10.4}
        />
        <g filter="url(#icon-lusail-minimap-markers_svg__A)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M123.995 73.166v-.228h-4.248v-1.2h5.688v1.464l-3.348 6.936h-1.464l3.372-6.972Z"
          />
        </g>
      </g>
      <g filter="url(#icon-lusail-minimap-markers_svg__B)">
        <rect
          width={20.8}
          height={20.8}
          x={148.387}
          y={124.27}
          fill="url(#icon-lusail-minimap-markers_svg__C)"
          rx={10.4}
        />
        <g filter="url(#icon-lusail-minimap-markers_svg__D)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M155.727 138.034v-1.02h1.392v.576l.48.48h2.184l.48-.48v-2.172l-.744.744h-2.676l-1.236-1.236v-2.82l1.236-1.236h3.576l1.236 1.236v5.928l-1.236 1.236h-3.456l-1.236-1.236Zm3.648-3.072.888-.888v-1.524l-.48-.48h-2.304l-.48.48v1.932l.48.48h1.896Z"
          />
        </g>
      </g>
      <g filter="url(#icon-lusail-minimap-markers_svg__E)">
        <rect
          width={20.8}
          height={20.8}
          x={173.051}
          y={164.979}
          fill="url(#icon-lusail-minimap-markers_svg__F)"
          rx={10.4}
        />
        <g filter="url(#icon-lusail-minimap-markers_svg__G)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m179.291 173.055-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.263 5.592v-5.736l1.332-1.332h3.624l1.332 1.332v5.736l-1.332 1.332h-3.624l-1.332-1.332Zm4.308.132.588-.576v-4.848l-.588-.576h-2.328l-.588.576v4.848l.588.576h2.328Z"
          />
        </g>
      </g>
      <g filter="url(#icon-lusail-minimap-markers_svg__H)">
        <rect
          width={20.8}
          height={20.8}
          x={221.484}
          y={124.27}
          fill="url(#icon-lusail-minimap-markers_svg__I)"
          rx={10.4}
        />
        <g filter="url(#icon-lusail-minimap-markers_svg__J)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m229.342 132.346-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm4.739 0-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
          />
        </g>
      </g>
      <g filter="url(#icon-lusail-minimap-markers_svg__K)">
        <rect
          width={20.8}
          height={20.8}
          x={279.727}
          y={78.509}
          fill="url(#icon-lusail-minimap-markers_svg__L)"
          rx={10.4}
        />
        <g filter="url(#icon-lusail-minimap-markers_svg__M)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m286.43 86.585-1.836.948V86.25l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.07 5.16 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236H294l1.236 1.236v1.752l-4.308 3.972v.252h4.356v1.188H289.5v-1.764Z"
          />
        </g>
      </g>
      <g filter="url(#icon-lusail-minimap-markers_svg__N)">
        <rect
          width={20.8}
          height={20.8}
          x={311.223}
          y={78.509}
          fill="url(#icon-lusail-minimap-markers_svg__O)"
          rx={10.4}
        />
        <g filter="url(#icon-lusail-minimap-markers_svg__P)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m317.756 86.585-1.836.948V86.25l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.023 5.688v-1.188h1.392v.768l.468.456h2.28l.468-.456V90.33l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34l-1.236 1.236h-3.528l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-lusail-minimap-markers_svg__Q)">
        <rect
          width={20.8}
          height={20.8}
          x={328.16}
          y={110.898}
          fill="url(#icon-lusail-minimap-markers_svg__R)"
          rx={10.4}
        />
        <g filter="url(#icon-lusail-minimap-markers_svg__S)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m334.834 118.974-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm6.803 5.316h-4.08v-1.572l3.684-5.22h1.788v5.592h1.02v1.2h-1.02v1.608h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
          />
        </g>
      </g>
      <g filter="url(#icon-lusail-minimap-markers_svg__T)">
        <rect
          width={20.8}
          height={20.8}
          x={314.492}
          y={184.591}
          fill="url(#icon-lusail-minimap-markers_svg__U)"
          rx={10.4}
        />
        <g filter="url(#icon-lusail-minimap-markers_svg__V)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m321.008 192.667-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.143 5.688v-1.224h1.392v.804l.468.456h2.256l.468-.456v-2.064l-.468-.468h-3.996v-4.212h5.688v1.2h-4.32v1.812h3.24l1.248 1.248v2.904l-1.236 1.236h-3.504l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-lusail-minimap-markers_svg__W)">
        <rect
          width={20.8}
          height={20.8}
          x={338.562}
          y={287.998}
          fill="url(#icon-lusail-minimap-markers_svg__X)"
          rx={10.4}
        />
        <g filter="url(#icon-lusail-minimap-markers_svg__Y)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m344.979 296.074-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.262 5.688v-5.928l1.236-1.236h3.528l1.236 1.236v1.104h-1.392v-.66l-.48-.48h-2.256l-.48.48v2.256l.792-.78h2.628l1.236 1.236v2.772l-1.236 1.236h-3.576l-1.236-1.236Zm4.176.036.48-.48v-1.884l-.48-.48h-1.8l-.984 1.008v1.356l.48.48h2.304Z"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="icon-lusail-minimap-markers_svg__c"
        width={58.254}
        height={80.835}
        x={132.066}
        y={288.111}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={3}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={4} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__d"
        width={36.801}
        height={36.8}
        x={35.195}
        y={281.107}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__f"
        width={19.227}
        height={24.4}
        x={43.586}
        y={287.707}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__g"
        width={36.801}
        height={36.8}
        x={55.996}
        y={230.592}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__i"
        width={21.832}
        height={24.4}
        x={63.352}
        y={237.192}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__j"
        width={36.801}
        height={36.8}
        x={36.98}
        y={180.968}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__l"
        width={22}
        height={24.4}
        x={44.168}
        y={187.568}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__m"
        width={36.801}
        height={36.8}
        x={7.563}
        y={93.31}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__o"
        width={22.492}
        height={24.4}
        x={14.59}
        y={99.91}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__p"
        width={36.801}
        height={36.8}
        x={39.355}
        y={55.869}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__r"
        width={21.977}
        height={24.4}
        x={46.645}
        y={62.469}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__s"
        width={36.801}
        height={36.8}
        x={76.797}
        y={157.791}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__u"
        width={22.051}
        height={24.4}
        x={84.106}
        y={164.391}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__v"
        width={36.801}
        height={36.8}
        x={148.41}
        y={76.669}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__x"
        width={22.238}
        height={24.4}
        x={155.566}
        y={83.269}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__y"
        width={36.801}
        height={36.8}
        x={104.434}
        y={59.138}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__A"
        width={21.688}
        height={24.4}
        x={111.746}
        y={65.738}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__B"
        width={36.801}
        height={36.8}
        x={140.387}
        y={118.27}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__D"
        width={22.051}
        height={24.4}
        x={147.605}
        y={124.87}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__E"
        width={36.801}
        height={36.8}
        x={165.051}
        y={158.979}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__G"
        width={27.383}
        height={24.4}
        x={169.457}
        y={165.58}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__H"
        width={36.801}
        height={36.8}
        x={213.484}
        y={118.27}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__J"
        width={23.965}
        height={24.4}
        x={219.508}
        y={124.87}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__K"
        width={36.801}
        height={36.8}
        x={271.727}
        y={72.509}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__M"
        width={26.691}
        height={24.4}
        x={276.594}
        y={79.109}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__N"
        width={36.801}
        height={36.8}
        x={303.223}
        y={72.509}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__P"
        width={26.855}
        height={24.4}
        x={307.922}
        y={79.109}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__Q"
        width={36.801}
        height={36.8}
        x={320.16}
        y={104.898}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__S"
        width={27.047}
        height={24.4}
        x={325}
        y={111.499}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__T"
        width={36.801}
        height={36.8}
        x={306.492}
        y={178.591}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__V"
        width={26.953}
        height={24.4}
        x={311.172}
        y={185.191}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__W"
        width={36.801}
        height={36.8}
        x={330.562}
        y={281.998}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <filter
        id="icon-lusail-minimap-markers_svg__Y"
        width={27.145}
        height={24.4}
        x={335.145}
        y={288.598}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9534_166400"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9534_166400"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9534_166400"
          result="effect2_dropShadow_9534_166400"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9534_166400"
          result="shape"
        />
      </filter>
      <linearGradient
        id="icon-lusail-minimap-markers_svg__b"
        x1={8}
        x2={367.15}
        y1={188.293}
        y2={188.293}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4FC5BA" />
        <stop offset={1} stopColor="#4FC5BA" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="icon-lusail-minimap-markers_svg__e"
        x1={63.996}
        x2={43.195}
        y1={287.107}
        y2={307.907}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-lusail-minimap-markers_svg__h"
        x1={84.796}
        x2={63.996}
        y1={236.592}
        y2={257.392}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-lusail-minimap-markers_svg__k"
        x1={65.781}
        x2={44.98}
        y1={186.968}
        y2={207.769}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-lusail-minimap-markers_svg__n"
        x1={36.363}
        x2={15.563}
        y1={99.31}
        y2={120.11}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-lusail-minimap-markers_svg__q"
        x1={68.156}
        x2={47.355}
        y1={61.869}
        y2={82.669}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-lusail-minimap-markers_svg__t"
        x1={105.597}
        x2={84.797}
        y1={163.791}
        y2={184.591}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-lusail-minimap-markers_svg__w"
        x1={177.21}
        x2={156.41}
        y1={82.669}
        y2={103.47}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-lusail-minimap-markers_svg__z"
        x1={133.234}
        x2={112.434}
        y1={65.138}
        y2={85.938}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-lusail-minimap-markers_svg__C"
        x1={169.187}
        x2={148.387}
        y1={124.27}
        y2={145.07}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-lusail-minimap-markers_svg__F"
        x1={193.851}
        x2={173.051}
        y1={164.979}
        y2={185.78}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-lusail-minimap-markers_svg__I"
        x1={242.285}
        x2={221.484}
        y1={124.27}
        y2={145.07}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-lusail-minimap-markers_svg__L"
        x1={300.527}
        x2={279.727}
        y1={78.509}
        y2={99.31}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-lusail-minimap-markers_svg__O"
        x1={332.023}
        x2={311.223}
        y1={78.509}
        y2={99.31}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-lusail-minimap-markers_svg__R"
        x1={348.96}
        x2={328.16}
        y1={110.898}
        y2={131.699}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-lusail-minimap-markers_svg__U"
        x1={335.293}
        x2={314.492}
        y1={184.591}
        y2={205.391}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-lusail-minimap-markers_svg__X"
        x1={359.363}
        x2={338.563}
        y1={287.998}
        y2={308.798}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <clipPath id="icon-lusail-minimap-markers_svg__a">
        <path fill="#fff" d="M0 0h375v375H0z" />
      </clipPath>
    </defs>
  </svg>
));
export default SvgIconLusailMinimapMarkers;
